import * as Types from '../graphql.generated';

export type Polygon_FragmentFragment = { __typename?: 'Polygon' } & Pick<
    Types.Polygon,
    'geoType' | 'polygons' | 'radius'
> & {
        geoData?: Types.Maybe<
            { __typename?: 'GeoData' } & Pick<
                Types.GeoData,
                | 'alias'
                | 'aliasId'
                | 'aliasIds'
                | 'areaId'
                | 'areaName'
                | 'areaStreetId'
                | 'coordinates'
                | 'countryId'
                | 'countyAreaId'
                | 'countyAreaName'
                | 'identifier'
                | 'incode'
                | 'laCode'
                | 'level'
                | 'outcode'
                | 'postTownId'
                | 'postTownName'
                | 'postalArea'
                | 'regionId'
                | 'regionName'
            >
        >;
    };

export const Polygon_FragmentFragmentDoc = `
    fragment POLYGON_FRAGMENT on Polygon {
  geoData {
    alias
    aliasId
    aliasIds
    areaId
    areaName
    areaStreetId
    coordinates
    countryId
    countyAreaId
    countyAreaName
    identifier
    incode
    laCode
    level
    outcode
    postTownId
    postTownName
    postalArea
    regionId
    regionName
  }
  geoType
  polygons
  radius
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
